<template>
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.6173 40.0754C41.1838 35.0755 44.0752 24.0777 39.0753 15.5112C34.0755 6.94461 23.0777 4.05324 14.5111 9.05312C5.94457 14.053 3.0532 25.0508 8.05308 33.6173C13.053 42.1839 24.0507 45.0753 32.6173 40.0754Z"
      fill="#E7EEF1"
    />
    <path
      d="M42.9576 49.7081V30.3116C39.7823 25.563 33.8268 23.1277 27.8714 23.1277C21.9159 23.1277 15.9604 25.563 12.7852 30.3116V49.7081H42.9576Z"
      fill="white"
    />
    <path
      d="M35.0566 15.2255H40.0854"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M41.5215 15.2255H42.9583"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M44.3955 15.2255H45.8323"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M45.832 11.6334H47.2688"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M48.7051 11.6335H50.1419"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M24.2803 11.6335H31.3421C31.6581 10.9151 32.4053 10.3188 33.2673 10.3188C33.5403 10.3188 33.8061 10.3547 34.0432 10.4481C34.5245 9.16222 35.7673 8.24268 37.2257 8.24268C39.1007 8.24268 40.6237 10.2039 40.6237 11.6407H44.3952"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M7.03906 15.2255H9.88389C10.358 14.5071 11.3422 13.7528 12.5204 13.8965C13.0376 13.0128 13.9787 12.3447 15.0779 12.3447C16.7086 12.3447 18.0304 13.7887 18.0448 15.2255H24.9988"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M26.4355 15.2255H27.8723"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M29.3086 15.2255H30.7454"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M27.8716 38.9323H17.0957V48.9897H27.8716V38.9323Z"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M38.6479 38.9323H27.8721V48.9897H38.6479V38.9323Z"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M33.6196 28.8749H22.8438V38.9323H33.6196V28.8749Z"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M12.7852 30.3116V49.7082"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M42.958 30.3116V49.7082"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M27.8719 19.5358C19.9696 19.5358 13.7627 23.0415 9.91211 28.1565L12.7857 30.3116C15.961 25.5631 21.9164 23.1277 27.8719 23.1277C33.8273 23.1277 39.7828 25.5631 42.9581 30.3116L45.8316 28.1565C41.9811 23.0415 35.7742 19.5358 27.8719 19.5358Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.0275 28.8749H26.4355V31.7484H30.0275V28.8749Z"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0275 28.8749H26.4355V31.7484H30.0275V28.8749Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.2804 38.9323H20.6885V41.8058H24.2804V38.9323Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M35.0558 38.9323H31.4639V41.8058H35.0558V38.9323Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
